<div class="uf">
  <p class="uf-muted" *ngIf="view.loading">Loading&hellip;</p>
  <p class="uf-error" role="alert" *ngIf="view.loadError">Couldn't load the items. Close this and try again.</p>
  <p class="uf-muted" *ngIf="!view.loading && !view.loadError && !view.groups.length">No items from Sage are waiting for a unit.</p>

  <ng-container *ngIf="!view.loading && view.groups.length">
    <div class="mk-banner warn">
      <i class="bi bi-info-circle" aria-hidden="true"></i>
      <div><b>{{ banner.lead }}</b>{{ banner.rest }}</div>
    </div>

    <!-- No item type choice for now (user, 23/10/2026): each item keeps the type saved on it. -->
    <app-unit-fix-group
      *ngFor="let group of view.groups; trackBy: trackGroup"
      [group]="group"
      [units]="view.units"
      [saving]="groupSaving(group)"
      [idPrefix]="idPrefix"
      (groupUnitChange)="groupUnitChange.emit({ group: group, uomId: $event })"
      (itemUnitChange)="itemUnitChange.emit($event)"
    ></app-unit-fix-group>
  </ng-container>

  <div class="uf-footer">
    <div class="uf-error" role="alert" *ngIf="view.error">{{ view.error }}</div>
    <div class="uf-actions">
      <button type="button" class="btn-secondary" [disabled]="saving" (click)="close.emit()">Close</button>
      <button type="button" class="btn-teal-gradient" [disabled]="!canApply" (click)="apply.emit()">{{ applyLabel }}</button>
    </div>
  </div>
</div>
